<template>
  <div class="p-grid">
    <div class="p-col-6 p-md-4 p-lg-2">
      <AppWidgetCount
        :loading="loading"
        :value="values.count"
        v-tooltip.top="'Quantidade de bovinos encontrado pela pesquisa.'"
        title="Bovinos"
        valueColor="black"
        valueBackgroundColor="#F7F7F7"
      />
    </div>

    <div class="p-col-6 p-md-4 p-lg-2">
      <AppWidgetCount
        title="Touros"
        :value="values.bullCount"
        :valueColor="bovineColors[bovineTypes.TOURO].color"
        :valueBackgroundColor="bovineColors[bovineTypes.TOURO].background"
        :loading="loading"
      />
    </div>

    <div class="p-col-6 p-md-4 p-lg-2">
      <AppWidgetCount
        title="Bois"
        :value="values.oxCount"
        :valueColor="bovineColors[bovineTypes.BOI].color"
        :valueBackgroundColor="bovineColors[bovineTypes.BOI].background"
        :loading="loading"
      />
    </div>

    <div class="p-col-6 p-md-4 p-lg-2">
      <AppWidgetCount
        title="Vacas"
        :value="cowCount"
        :valueColor="bovineColors[bovineTypes.VACA].color"
        :valueBackgroundColor="bovineColors[bovineTypes.VACA].background"
        :loading="loading"
        v-tooltip.top="cowTooltip"
      />
    </div>

    <div class="p-col-6 p-md-4 p-lg-2">
      <AppWidgetCount
        title="Bezerros"
        :value="values.calfCount"
        :valueColor="bovineColors[bovineTypes.BEZERRO].color"
        :valueBackgroundColor="bovineColors[bovineTypes.BEZERRO].background"
        :loading="loading"
      />
    </div>

    <div class="p-col-6 p-md-4 p-lg-2">
      <AppWidgetCount
        title="Bezerras"
        :value="values.heiferCount"
        :valueColor="bovineColors[bovineTypes.BEZERRA].color"
        :valueBackgroundColor="bovineColors[bovineTypes.BEZERRA].background"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { bovineTypes, bovineColors } from '../../../lib/bovines';

export default {
  props: {
    values: {
      type: Object,
    },
    loading: Boolean,
  },
  data() {
    return {
      bovineTypes,
      bovineColors,
    };
  },
  computed: {
    cowCount() {
      return (
        (this.values.cowCount || 0) +
        (this.values.nulliparousCount || 0) +
        (this.values.primiparousCount || 0) +
        (this.values.multiparaCount || 0)
      );
    },
    cowTooltip() {
      return [
        `Vacas (${this.values.cowCount || 0})`,
        `Nulíparas (${this.values.nulliparousCount || 0})`,
        `Primíparas (${this.values.primiparousCount || 0})`,
        `Multíparas (${this.values.multiparaCount || 0})`,
      ].join(', ');
    },
  },
};
</script>

<style scoped>
</style>
